module.exports = __webpack_public_path__ + "static/media/Nguyen-Thi-Hoa-Huyen.1c030593.jpeg";